//=require vendors/_intense-images.js

$(function() {
  'use strict';

  var $zooms = $('.js-zoom');

  $zooms.each(function(index, zoom) {
    var $body = $('body'),
        $zoom = $(zoom),
        $button = $zoom.find('.js-zoom-button'),
        buttonCenter = {
          'x': $button.outerWidth() / 2,
          'y': $button.outerHeight() / 2
        };

    if(!Modernizr.touchevents) {
      Intense(zoom);
    }

    $zoom.on('mousemove', function(event) {
      if(!Modernizr.touchevents) {

        if($(event.target).parents('[href]').length <= 0 && !$button.hasClass('is-moving')) {
          $button.addClass('is-moving');
        }

        if($(event.target).parents('[href]').length > 0 && $button.hasClass('is-moving')) {
          $button.removeClass('is-moving');
        }

        $button.css({
          left: event.pageX - buttonCenter.x,
          top: event.pageY - buttonCenter.y
        });
      }
    });

    $zoom.hover(function(event) {
      $button.addClass('is-moving');
    }, function(event) {
      $button.removeClass('is-moving');
    });
  });
});
